interface ListState<T> {
  loading: boolean
  loadingState: boolean
  data?: T[]
  items?: T[]
  page?: number
  totalPages?: number
  totalItems?: number
}

interface ObjectState<T> {
  loading: boolean
  loadingState: boolean
  data: T
}

interface LocationPoint {
  id: number
  name: string
}

interface LocationItem {
  id?: number
  name?: string
  points?: LocationPoint[]
  image?: string
  minPrice?: string
  status?: boolean
}

interface RootState {
  user: ObjectState<any>
  banners: ListState<any>
  termsAndConditions: ObjectState<any>
  privacyPolicy: ObjectState<any>
  aboutUs: ObjectState<any>
  refundPolicy: ObjectState<any>
  cancellationPolicy: ObjectState<any>
  bookingPolicy: ObjectState<any>
  reschedulePolicy: ObjectState<any>
  dashboard: ObjectState<any>
  pushNotification: ListState<any>
  notifications: ListState<any>
  location: ListState<LocationItem>
  users: ListState<any>
  inidividualUser: ObjectState<any>
  aboutUsSeo: ObjectState<any>
  privacyPolicySeo: ObjectState<any>
  bookingPolicySeo: ObjectState<any>
  cancellationPolicySeo: ObjectState<any>
  termsAndConditionsSeo: ObjectState<any>
  reschedulePolicySeo: ObjectState<any>
  refundPolicySeo: ObjectState<any>
  selectedChat: null
  supportMessages: ListState<any>
  maintainanceMode: ObjectState<any>
  commissionSetting: ObjectState<any>
  rescheduleSetting: ObjectState<any>
  cancellationSetting: ObjectState<any>
  appSettings: ObjectState<any>
  bookings: ListState<any>
  amenities: ListState<any>
  vehicles: ListState<any>
  individualVehicle: ObjectState<any>
  offers: ListState<any>
  transaction: ListState<any>
  inquiry: ListState<any>
  config: ObjectState<any>
}

const initialState: RootState = {
  user: {
    loading: true,
    loadingState: true,
    data: {},
  },

  banners: {
    loading: true,
    loadingState: true,
    data: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },
  amenities: {
    loading: true,
    loadingState: true,
    data: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },

  termsAndConditions: {
    loading: true,
    loadingState: true,
    data: {},
  },
  privacyPolicy: {
    loading: true,
    loadingState: true,
    data: {},
  },
  aboutUs: {
    loading: true,
    loadingState: true,
    data: {},
  },
  cancellationPolicy: {
    loading: true,
    loadingState: true,
    data: {},
  },
  bookingPolicy: {
    loading: true,
    loadingState: true,
    data: {},
  },
  refundPolicy: {
    loading: true,
    loadingState: true,
    data: {},
  },
  reschedulePolicy: {
    loading: true,
    loadingState: true,
    data: {},
  },

  dashboard: {
    data: {},
    loading: true,
    loadingState: true,
  },

  pushNotification: {
    loading: true,
    loadingState: true,
    items: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },
  notifications: {
    loading: true,
    loadingState: true,
    items: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },

  location: {
    loading: true,
    loadingState: true,
    items: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },
  users: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  inidividualUser: {
    loading: true,
    loadingState: true,
    data: {},
  },

  aboutUsSeo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  privacyPolicySeo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  bookingPolicySeo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  cancellationPolicySeo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  termsAndConditionsSeo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  reschedulePolicySeo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  refundPolicySeo: {
    loading: true,
    loadingState: true,
    data: {},
  },

  selectedChat: null,
  supportMessages: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  maintainanceMode: {
    loading: true,
    loadingState: true,
    data: {},
  },
  commissionSetting: {
    loading: true,
    loadingState: true,
    data: {},
  },
  rescheduleSetting: {
    loading: true,
    loadingState: true,
    data: {},
  },
  cancellationSetting: {
    loading: true,
    loadingState: true,
    data: {},
  },
  appSettings: {
    loading: true,
    loadingState: true,
    data: {},
  },
  bookings: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  vehicles: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  individualVehicle: {
    data: {},
    loading: true,
    loadingState: true,
  },
  offers: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  transaction: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  inquiry: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  config: {
    data: {},
    loading: true,
    loadingState: true,
  },
}

export default initialState
